import styled, { css, createGlobalStyle } from 'styled-components'

import Avatar from './Avatar'

export const Container = styled.div`
  margin: 0.625rem 0;
`

export const Section = styled.div`
  margin-bottom: 1rem;
`

export const SectionTitle = styled.div`
  color: rgb(91, 95, 103);
  font-size: 10px;
  font-weight: 700;
  line-height: 0.75rem;
  margin-bottom: 0.375rem;
  margin-top: 1.875rem;
  text-transform: uppercase;
`

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  color: white;
  font-weight: 700;
  line-height: 0.75rem;
  margin-bottom: 0.75rem;
`

export const Arrow = styled.span<{ isOpen: boolean }>`
  transition: transform 0.3s ease;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`

export const ItemList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`

export const Item = styled.li`
  font-family: Lato;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 900;
  line-height: 1.5rem;
  color: white;
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  cursor: pointer;

  svg {
    margin-right: 0.375rem;
  }
`

export const SubItem = styled.div`
  font-family: Lato;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  color: white;
  margin-bottom: 0.25rem;
  cursor: pointer;
`

export const MenuContainer = styled.div<{ isAdmin?: boolean }>`
  background-color: #1e1e21;
  border-radius: 0.5rem;
  margin: 0 0 10px;
`

export const ChatAndActivityMenuItem = styled.a<{ isLast?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.625rem;
  cursor: pointer;
  color: white;
  border-bottom: ${({ isLast }) => (isLast ? 'none' : '1px solid #030308')};
  list-style: none;
  text-decoration: none;

  &:hover {
    text-decoration: none;
    background-color: #2a2a2e;
    color: white;
    ${({ isLast }) =>
      isLast
        ? `
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    `
        : `
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    `};
  }
`

export const Icon = styled.img`
  width: 1.125rem;
  height: 1.125rem;
`

export const Label = styled.span`
  flex-grow: 1;
  margin-left: 0.625rem;

  font-family: Lato;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 900;
  line-height: 1.5rem;
`

export const Badge = styled.span`
  background-color: #1936d0;
  color: white;
  border-radius: 0.75rem;
  padding: 3px 5.5px;
  width: 0.875rem;
  height: 0.875rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Lato;
  font-size: 0.5rem;
  font-weight: 700;
  line-height: normal;
`

export const LogoWrap = styled.a`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`

export const Logo = styled.img`
  height: 1.875rem;
  cursor: pointer;
`

export const SearchIcon = styled.img`
  width: 1.125rem;
  height: 1.125rem;
  cursor: pointer;
`

export const Wrap = styled.div<{ isManager?: boolean; isNavCollapsed?: boolean }>`
  background-color: #030308;
  bottom: 0;
  display: flex;
  flex-direction: column;
  height: 100vh;
  left: 0;
  overflow-y: auto;
  padding: 1rem;
  position: fixed;
  scrollbar-width: none;
  top: 0;
  width: ${({ isNavCollapsed }) => (isNavCollapsed ? '4.5rem' : '13.125rem')};
  z-index: 15;

  @media (max-width: 64rem) {
    display: none;
  }
`

export const MenuItem = styled.div<{ hasSubMenu: boolean; isSelected: boolean }>`
  > a {
    position: relative;
    font-size: 0.875rem;
    font-weight: 900;
    line-height: 1.5rem;
    display: flex;
    align-items: center;
    gap: 1.125rem;
    padding: 0.5rem 0.625rem;
    cursor: pointer;
    text-decoration: none;
    color: white;
    /* stylelint-disable */
    font-weight: ${({ isSelected }) => (isSelected ? 900 : 700)};
    /* stylelint-enable */

    ${({ isSelected }) =>
      isSelected &&
      `
      border-radius: 0.75rem;
      background: #1e1e21;
    `};

    ${({ hasSubMenu }) =>
      hasSubMenu &&
      `
      padding: 0.5rem 0.625rem;
      margin-bottom: 0;
    `};

    &:hover {
      border-radius: 0.75rem;
      background: rgb(30, 30, 33);
      animation: 0.2s ease 0s 1 normal none running;
    }

    > img {
      width: 1.25rem;
      height: 1.25rem;
    }
  }
`

export const UserAvatarWrap = styled.div<{ isOpen?: boolean; isNavCollapsed?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 41px;
  background: #1e1e21;
  padding: ${({ isNavCollapsed }) => (isNavCollapsed ? '0' : '5px 12px 5px 5px')};
  margin-bottom: 11px;
  cursor: pointer;

  ${({ isNavCollapsed }) =>
    isNavCollapsed &&
    `
    background: 0;
    margin: 0 auto 11px;

    img {
      cursor: pointer;
    }
  `} svg {
    transition: transform 0.2s ease;
    transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
`
export const BrandNameWrapper = styled.div`
  display: flex;
  align-items: center;

  .userName {
    font-family: Lato;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.5rem;
    color: white;
    max-width: 6.25rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const AvatarStyled = styled.img<{ displayFallback: boolean; isNavCollapsed?: boolean }>`
  display: grid;
  margin-right: ${({ isNavCollapsed }) => (isNavCollapsed ? '0' : '0.5rem')};
  place-content: center;
  background: ${({ displayFallback }) => (displayFallback ? '#1936d0' : 'white')};
  box-shadow: 0 2px 3rem 0 #0000001a;
  border-radius: 50%;
  cursor: default;
  width: 2rem;
  height: 2rem;
  object-fit: cover;

  span {
    font-size: 1.5rem;
    background: ${({ displayFallback }) => (displayFallback ? '#1936d0' : 'white')};
    color: white;
    width: 2rem;
    height: 2rem;
    cursor: ${({ isNavCollapsed }) => (isNavCollapsed ? 'pointer' : 'default')};
  }

  img {
    width: 2rem;
    height: 2rem;
    cursor: ${({ isNavCollapsed }) => (isNavCollapsed ? 'pointer' : 'default')};
  }
`

export const AvatarMissing = styled.div<{ isNavCollapsed?: boolean }>`
  display: grid;
  margin-right: ${({ isNavCollapsed }) => (isNavCollapsed ? '0' : '0.5rem')};
  place-content: center;
  background: #1936d0;
  box-shadow: 0 2px 3rem 0 #0000001a;
  border-radius: 50%;
  cursor: default;
  max-width: 2rem;
  max-height: 2rem;

  span {
    font-size: 11px;
    font-weight: 700;
    color: white;
    width: 2rem;
    height: 2rem;
    line-height: 2rem;
    cursor: ${({ isNavCollapsed }) => (isNavCollapsed ? 'pointer' : 'default')};
    text-align: center;
  }
`
export const DropdownSectionTitle = styled.span<{ isModal: boolean }>`
  color: ${({ isModal }) => (isModal ? '#9b9b9b' : '#5b5f67')};
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: 12px;
`
export const BrandLink = styled.a`
  color: inherit;
  text-decoration: none;
  max-width: 100%;
`
export const BrandItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  transition: opacity 0.2s ease;

  &:hover {
    cursor: pointer;
    opacity: 0.5;
    /* stylelint-disable */
    animation: hover 0.2s ease;
    /* stylelint-enable */
  }

  svg {
    width: 16px;
  }
`

export const BrandAvatar = styled(Avatar)`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  margin-right: 10px;
`

export const BrandName = styled.span`
  color: rgb(30, 30, 33);
  font-size: 0.75rem;
  font-weight: 700;
  margin-right: 0.25rem;
  width: fit-content;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Account = styled(BrandName)`
  margin-left: 0.375rem;
  font-size: 0.875rem;
`

export const AddSubBrand = styled.a`
  background: none;
  border: none;
  color: #1e1e21;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: normal;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  margin-bottom: 7px;
  width: 100%;
  transition: opacity 0.2s ease;
  text-decoration: none;

  &:hover {
    color: #1e1e21;
    opacity: 0.5;
    /* stylelint-disable */
    animation: hover 0.2s ease;
    /* stylelint-enable */
  }
`

export const LogoutButton = styled.button`
  background: none;
  border: none;
  color: #1e1e21;
  font-family: Lato;
  font-size: 0.875rem;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  width: 100%;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.5;
    /* stylelint-disable */
    animation: hover 0.2s ease;
    /* stylelint-enable */
  }
`

export const ModalSeparator = styled.div`
  height: 1px;
  width: 100%;
  background-color: #d6d6d6;
  margin-top: -10px;
`
export const BrandList = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
`
export const hideScrollbar = css`
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none; /* Safari and Chrome */
  }
`
export const ScrollableSection = styled.div<{ itemCount: number }>`
  position: relative;
  width: 100%;
  overflow-y: auto;
  max-height: 5.75rem;
  mask-image: ${({ itemCount }) => {
    if (itemCount <= 2) {
      return 'none'
    }
    return 'linear-gradient(to bottom, black calc(100% - 30px), transparent 100%)'
  }};
  ${hideScrollbar};
`
export const ModalContent = styled.div`
  position: fixed;
  top: 7.5rem;
  left: 1rem;
  width: 16rem;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
  border-radius: 8px;
  background: var(--white-2, white);
  box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.1);
  z-index: 9999;
  overflow-y: auto;
  ${hideScrollbar};
`
export const Divider = styled.div`
  height: 6px;
`
export const TopWrapp = styled.div`
  align-items: center;
  border: 1px solid transparent;
  display: flex;
  justify-content: space-between;
`
export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
  margin-bottom: 0.75rem;

  img {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    display: block;
    width: 16px;
    height: 16px;
    filter: invert(1) brightness(0.3);
  }
`
export const SearchSeparator = styled.div`
  height: 1px;
  width: 100%;
  background-color: rgb(214, 214, 214);
  margin-top: -10px;
`

export const SearchInput = styled.input`
  width: 100%;
  height: 1.5rem;
  padding: 0.5rem 0.5rem 0.5rem 1.5rem;
  border: none;
  background: white;
  color: rgb(30, 30, 33);
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.375rem;
  outline: none;
`
export const ResultLink = styled.a`
  display: flex;
  align-items: center;
  width: 100%;
  transition: opacity 0.2s;
  text-decoration: none;
  color: inherit;
  margin-bottom: 0.625rem;

  &:hover {
    opacity: 0.5;

    /* stylelint-disable */
    animation: hoverAnimation 0.2s ease 0s 1 normal none running hover;

    /* stylelint-enable */

    @keyframes hoverAnimation {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
  }
`

export const ResultName = styled.span`
  color: rgb(30, 30, 33);
  display: block;
  font-size: 0.75rem;
  font-weight: 700;
  margin-right: 0.25rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: fit-content;
`
export const AvatarWrapper = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  margin-right: 10px;
`
export const NoAvatar = styled.div`
  background: rgb(25, 54, 208);
  color: white;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.688rem;
  font-weight: 700;
  line-height: 0.875rem;
  width: 1.5rem;
  height: 1.5rem;
`
export const ResultsWrapper = styled.div<{ count: number; recentBrands?: boolean }>`
  height: ${({ count, recentBrands }) => {
    if (count <= 1) {
      return '1.625rem'
    }
    if (count === 2) {
      return '3.875rem'
    }
    if (recentBrands) {
      return '5.875rem'
    }
    return '17.625rem'
  }};
  width: 100%;
  overflow-y: ${({ count }) => (count <= 2 ? 'hidden' : 'auto')};
  scrollbar-width: none;
  margin-bottom: 0.75rem;
  mask-image: ${({ count }) => {
    if (count <= 2) {
      return 'none'
    }
    return 'linear-gradient(to bottom, black calc(100% - 30px), transparent 100%)'
  }};
  ${hideScrollbar};
`

export const TooltipWrapper = styled.div`
  backdrop-filter: blur(0.75rem);
  background: rgba(30, 30, 33, 0.9);
  border-radius: 0.5rem;
  color: white;
  font-family: Lato;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.25rem;
  padding: 0.5rem 1rem;
  z-index: 999999;
`
export const TooltipContent = createGlobalStyle`
  .tippy-arrow {
    display: inline-block;
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 6px solid #39393b;
    margin-bottom: -47px;

    /* stylelint-disable */
    margin-left: 46%;
    /* stylelint-enable */
  }
`
export const NavTrigger = styled.div<{ isNavCollapsed?: boolean }>`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: url(https://res.cloudinary.com/ninety-seconds/image/upload/v1674058986/arrow-left-white.svg)
    no-repeat center center #1e1e21;
  background-size: 4px;
  position: fixed;
  left: ${({ isNavCollapsed }) => (isNavCollapsed ? '60px' : '198px')};
  top: ${({ isNavCollapsed }) => (isNavCollapsed ? '68px' : '74px')};
  z-index: 16;
  ${({ isNavCollapsed }) =>
    isNavCollapsed &&
    css`
      rotate: 180deg;
    `};
`
export const Hr = styled.div`
  width: 2.75rem;
  height: 1px;
  background: #1e1e21;
  margin: 4px auto;
  display: list-item;
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/Navigation/Navigation.style.tsx